/**
 * @file
 * Accordion for basic pages and accordion module on brand book pages.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.content_accordion = {
    attach: function (context, settings) {

      if ($('.field--name-field-accordion').length) {
        $('.field--name-field-accordion').accordion({
          header: '.field--name-field-accordion-title',
          collapsible: true,
          active: false,
          heightStyle: 'content'
        });
      }

      if ($('.field--name-field-accordion-row').length) {
        $('.field--name-field-accordion-row').accordion({
          header: '.field--name-field-accordion-title',
          collapsible: true,
          active: false,
          heightStyle: 'content'
        });
      }
    }
  };

})(jQuery, Drupal);
